/* Apparition au scroll. Plusieurs sections chargent ce fichier : le garde-fou
   evite d'installer dix observateurs sur les memes elements. */
(function () {
  if (window.__skydriftReveal) return;
  window.__skydriftReveal = true;

  const cibles = document.querySelectorAll(".reveal");
  if (!cibles.length) return;

  // sur une fiche produit, rien n'attend le defilement pour s'afficher
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      document.querySelector('main[data-template^="product"]')) {
    cibles.forEach(c => c.classList.add("vu"));
    return;
  }

  const oeil = new IntersectionObserver(entrees => {
    entrees.forEach(e => {
      if (!e.isIntersecting) return;
      e.target.classList.add("vu");
      oeil.unobserve(e.target);   // une fois vu, c'est vu
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });

  cibles.forEach(c => oeil.observe(c));
})();
